/**
 * Xman
 *
 * @export
 * @param {*} cb
 */
export default function Xman(cb) {
  if (cb) {
    if (window.SCHD_COMS.SCXman) {
      cb(window.SCHD_COMS.SCXman);
    } else if (window.SCHD_COMS && window.SCHD_COMS.use) {
      window.SCHD_COMS.use(['xman'], () => {
        if (window.SCHD_COMS.SCXman) {
          cb(window.SCHD_COMS.SCXman);
        }
      });
    }
  }
}